import React from 'react'
import NavigationBar from '../components/NavigationBar';
import { database } from '../firebase';
import update from 'immutability-helper'; 
import { Container, Row, Col, Button, Spinner } from 'reactstrap';
import Auth from '../config/Auth';
import Evento from '../components/Evento';

class Inicio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      existeMais: true,
      items:[],
      params: {
        last: 0,
        pageSize: 12,
      }
    }

    this.loadFestas = this.loadFestas.bind(this);
  }

  componentDidMount() {
    this.loadFestas();
  }

  loadFestas() {
    if (this.state.existeMais) {
      this.setState(state => update(state, {
        isLoading: { $set: true }
      }), () => {
        var reference = database.ref('festas')

        if (Auth.isAuthenticated && false) {
          if (this.state.params.last === 0) {
            reference = database.ref('festas')
              .orderByChild('info/dataTimestampInverse')
              .endAt(this.state.params.last)
              .limitToFirst(this.state.params.pageSize)
          }
          else {
            reference = database.ref('festas')
              .orderByChild('info/dataTimestampInverse')
              .startAt(this.state.params.last)
              .limitToLast(this.state.params.pageSize)
          }

          reference.once('value', (snap) => {
            let dic = snap.val()

            var items = []
            for (let key in dic) {
              items.push(dic[key])
            }

            this.setState(state => update(state, {
              isLoading: { $set: false },
              existeMais: { $set: items.length === this.state.params.pageSize },
              items: { $set: this.state.items === [] ? items : this.state.items.concat(items) },
              params: {
                last: { $set: items.length > 0 ? items[items.length - 1].info.dataTimestampInverse : this.state.params.last }
              }
            }), () => {

            })
          }, (error) => {
            console.log(error)
          })
        }
        else {
          if (this.state.params.last === 0) {
            reference = database.ref('festas')
              .orderByChild('info/dataTimestamp')
              .startAt(parseInt(Date.now() / 1000) - 42200)
              .limitToFirst(this.state.params.pageSize)
          }
          else {
            reference = database.ref('festas')
              .orderByChild('info/dataTimestamp')
              .startAt(parseInt(this.state.params.last))
              .limitToFirst(this.state.params.pageSize)
          }

          reference.once('value', (snap) => {
            let dic = snap.val()

            var items = []
            for (let key in dic) {
              items.push(dic[key])
            }

            this.setState(state => update(state, {
              isLoading: { $set: false },
              existeMais: { $set: items.length === this.state.params.pageSize },
              items: { $set: this.state.items === [] ? items : this.state.items.concat(items) },
              params: {
                last: { $set: items.length > 0 ? items[items.length - 1].info.dataTimestamp : this.state.params.last }
              }
            }), () => {

            })
          }, (error) => {
            console.log(error)
          })
        }
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar />
        <Container className="w-100 pl-0 pr-0" style={{ maxWidth: 100 + "%" }}><Row className="pl-0 pr-0 ml-0 mr-0 pt-1" > {
            this.state.items.length > 0 ?
              this.state.items.map((item, i) => {
                  const key = item.key
                  return ( <Evento key={i} id={key} index={i} festa={item} /> ) 
                })
              :
                null
          }
        </Row>
          <Row className="pl-0 pr-0 ml-0 mr-0">
            <Col xs={12} className="text-center pl-0 pr-0 ml-0 mr-0" > {
              this.state.existeMais === true ?
                this.state.isLoading ?
                  <Button color="secondary" style={{ margin: 0 + " auto", float: 'none' }} className="mb-1" disabled onClick={this.loadFestas}><Spinner className="spinner-grow spinner-grow-sm"></Spinner> Carregando...</Button>
                  :
                  <Button color="secondary" style={{ margin: 0 + " auto", float: 'none' }} className="mb-1" onClick={this.loadFestas}>Carregar mais</Button>
                :
                null
            }</Col>
          </Row>
        </Container>
      </React.Fragment>
    )
  }
}

export default (Inicio)